export const LIST_COURSE_REQUEST = "@listCourseReducer/LIST_COURSE_REQUEST";
export const LIST_COURSE_SUCCESS = "@listCourseReducer/LIST_COURSE_SUCCESS";
export const LIST_COURSE_FAILED = "@listCourseReducer/LIST_COURSE_FAILED";
